import React from 'react';

import { Heading } from '../../../../common/Styles';
import * as S from './BusinessDesignStyle';

const LeftTabContent = ({ isMobile, data = {} }) => {
	const { heading = '', subHeading = '', backgroundColor = '', desc = [] } = data;

	return (
		<S.TabWrapper right_M='116px' $width={`${isMobile ? '100%' : '48%'}`}>
			<S.LeftTabContentHeader bgColor={backgroundColor}>
				<Heading fontSize={`${isMobile ? '16px' : '22px'}`} color='#fff' marBt='8px'>
					{heading}
				</Heading>
				<S.LeftTabContentSubHeader>
					{subHeading}
				</S.LeftTabContentSubHeader>
			</S.LeftTabContentHeader>

			<S.UserList>
				{desc.map((itemList, index) => (
					<li key={index} id='userList'>
						<S.LeftSmallBar />
						<S.LiContent
							color='#000'
							fsize={`${isMobile ? '14px' : '16px'}`}>
							{itemList}
						</S.LiContent>
					</li>
				))}
			</S.UserList>
		</S.TabWrapper>
	);
};
export default LeftTabContent;
